export default __webpack_public_path__ + "static/media/mi1.ffdd522f.webp";